import React, { forwardRef, useEffect, useImperativeHandle, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { InputProps } from '../../models/type';
import CustomInput from '../Inputs/CustomInput';
import CustomSelect from '../Inputs/CustomSelect';
import { Box, Container, Divider, Grid } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import useAppUtils from '../../Utils/useAppUtils';
import CustomFileInput from '../Inputs/CustomFileInput';


interface Props {
  onSubmit: (data: unknown) => void;
  labelButtonSubmit?: string;
  titleForm?: string;
  initialValues: unknown;
  inputs: InputProps[];
  showButtons?: boolean;
  onFormChange?: (value: any) => void;
  validationSchema: any;
  onInputActionFun?: (type: string, file?: File, name?: string) => void;
  uploadingInProgress?: boolean;
  showTitle?: boolean;
}

const Form = forwardRef(({ ...props }: Props, ref) => {
  const {
    initialValues,
    inputs,
    onSubmit,
    validationSchema,
    titleForm,
    labelButtonSubmit = 'Submit',
    showButtons = true,
    onInputActionFun = null,
    uploadingInProgress = false,
    showTitle = true,
  } = props;

  const { alert, confirm } = useAppUtils();

  const formMethods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      // console.log('initialValues changed', validationSchema);
      return initialValues;
    }, [initialValues]),
  });
  const watchAllFields = formMethods.watch(); // when pass nothing as argument, you are watching everything

  useEffect(() => {
    formMethods.reset(initialValues);
  }, [initialValues]);
  useEffect(() => {
    const subscription = formMethods.watch((value, { name, type }) => {
      // console.log(value, name, type);
      if (props.onFormChange) {
        props.onFormChange(value);
      }
    });
    return () => subscription.unsubscribe();
  }, [formMethods.watch]);

  const handleSubmit = formMethods.handleSubmit(onSubmit);

  const onInputAction = (type, file: File, name) => {
    if (onInputActionFun) {
      onInputActionFun(type, file, name);
    }
  };

  const createInputs = () => {
    return inputs.map((inputProps) => {
      switch (inputProps.type) {
        case 'select':
          return <CustomSelect {...inputProps} key={inputProps.name} />;
        case 'file':
          return (
            <CustomFileInput
              uploadingInProgress={uploadingInProgress}
              onInputAction={onInputAction}
              {...inputProps}
              key={inputProps.name}
            />
          );
        // case 'checkbox':
        //   return (
        //     <CustomCheckbox {...inputProps} key={inputProps.name} />
        //   );
        // case 'radio':
        //   return (
        //     <CustomRadio {...inputProps} key={inputProps.name} />
        //   );
        default:
          return <CustomInput {...inputProps} key={inputProps.name} />;
      }
    });
  };

  useImperativeHandle(ref, () => ({
    onPredictSubmit() {
      handleSubmit();
    },
  }));

  return (
    <div id="form">
      {/* <h5></h5> */}
      {showTitle && (
        <Box className="hedading">
          <h4 className="title">{titleForm}</h4>
          <div className="line"></div>
        </Box>
      )}
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit}>
          {createInputs()}
          {showButtons && (
            <Grid item xs={6}>
              <button className="btn-custom">{labelButtonSubmit}</button>
              {/* <button  className='btn-custom'>Reset</button> */}
            </Grid>
          )}
        </form>
      </FormProvider>
    </div>
  );
});

export default Form;
